import React from 'react';
import ReactDOM from 'react-dom';
import {
	BrandDetailsProvider,
	BrandThemeProvider
} from 'dw-au-react-components';
import { ContentfulProvider } from './context/Contentful';
import PlpSeoTop from './Content/PlpSeoTop';
import PlpSeoBottom from './Content/PlpSeoBottom';

const App = ({ type, searchHeading = null }) => {
	return (
		<BrandDetailsProvider brandTag='wpe'>
			<BrandThemeProvider brandTag='wpe'>
				<ContentfulProvider type={type}>
					{type === 'top' ? (
						<PlpSeoTop searchHeading={searchHeading} />
					) : (
						<PlpSeoBottom />
					)}
				</ContentfulProvider>
			</BrandThemeProvider>
		</BrandDetailsProvider>
	);
};

const plp_seo_top = document.getElementById('plp_seo_top'),
	plp_seo_bottom = document.getElementById('plp_seo_bottom'),
	searchHeading = plp_seo_top.getAttribute('data-searchHeading');

ReactDOM.render(<App type='top' searchHeading={searchHeading} />, plp_seo_top);
ReactDOM.render(<App type='bottom' />, plp_seo_bottom);
